import { Root } from 'react-dom/client';
import i18n from 'i18next';
import { AddBizReactLoader } from '../../../../Js/React/loader';
import svTranslations from '../Admin/Locales/sv.json';
import enTranslations from '../Admin/Locales/en.json';
import LaxhjalpenStudentRegistrationPublicPage from '../Common/Components/StudentRegistration/LaxhjalpenStudentRegistrationPublicPage';
import LaxhjalpenUserParticipationPage from '../Common/Components/LaxhjalpenUserParticipationPage';
import LaxhjalpenUserParticipationWidget from '../Common/Components/LaxhjalpenUserParticipationWidget';
import LaxhjalpenGuardianParticipationPage from '../Common/Components/LaxhjalpenGuardianParticipationPage';
import { withFrontendContext } from '../../../../FrontEnd/Common/frontendStateContext';
import LaxhjalpenGuardianApprovalPage from './Components/LaxhjalpenGuardianApprovalPage';
// import { getInitializedPromise } from '../../../../Js/React/Services/legacy';

type LaxhjalpenWidgetParams = {
	hideOnNoData?: boolean;
	mode?: 'minimal' | 'default';
};

let root: Root | undefined;

i18n.addResourceBundle('sv', 'translation', svTranslations, true, true);
i18n.addResourceBundle('en', 'translation', enTranslations, true, true);

AddBizReactLoader(root, 'laxhjalpenstudentregistrationpublic', () => {
	return withFrontendContext(<LaxhjalpenStudentRegistrationPublicPage />);
});

AddBizReactLoader(root, 'laxhjalpenuserparticipation', () => {
	return withFrontendContext(<LaxhjalpenUserParticipationPage />);
});

AddBizReactLoader(root, 'laxhjalpenuserparticipationwidget', (e) => {
	const params = (e?.detail as { params?: LaxhjalpenWidgetParams })?.params;
	return withFrontendContext(<LaxhjalpenUserParticipationWidget hideOnNoData={params?.hideOnNoData} mode={params?.mode} />);
});

AddBizReactLoader(root, 'laxhjalpenuserparticipationwidgetprofile', (e) => {
	const params = (e?.detail as { params?: LaxhjalpenWidgetParams })?.params;
	return withFrontendContext(<LaxhjalpenUserParticipationWidget hideOnNoData={params?.hideOnNoData} mode={params?.mode} />);
});

AddBizReactLoader(root, 'laxhjalpenprofileparticipation', () => {
	return withFrontendContext(<LaxhjalpenGuardianParticipationPage />);
});

AddBizReactLoader(root, 'laxhjalpeneventguardianapproval', () => {
	return withFrontendContext(<LaxhjalpenGuardianApprovalPage />);
});

// const initFrontEndPromise = getInitializedPromise();

// initFrontEndPromise.then(() => {
// 	console.log('Laxhjalpen React Frontend initialized');
// });
